import React from 'react';
import type { HighlightPolaroidData } from '../../types';
import HighlightIllustration from './HighlightIllustration';
import '../../styles/highlight/HighlightPolaroid.css';

const TAPE_COLORS = {
  ochre: 'rgba(198,140,59,.55)',
  terracotta: 'rgba(194,90,58,.55)',
  sage: 'rgba(122,139,95,.55)',
} as const;

interface HighlightPolaroidProps {
  data: HighlightPolaroidData;
  illustrationLabel?: string;
}

interface PolaroidStyle extends React.CSSProperties {
  '--psl-hl-rot'?: string;
  '--psl-hl-tape'?: string;
}

const HighlightPolaroid: React.FC<HighlightPolaroidProps> = ({
  data,
  illustrationLabel,
}) => {
  const rotation = data.rotation ?? -3;
  const tape = TAPE_COLORS[data.tapeColor ?? 'ochre'];
  const style: PolaroidStyle = {
    '--psl-hl-rot': `${rotation}deg`,
    '--psl-hl-tape': tape,
  };

  return (
    <div className="psl-hl-polaroid-wrap">
      <div className="psl-hl-polaroid" style={style}>
        <span className="psl-hl-polaroid__tape" aria-hidden="true" />
        <div className="psl-hl-polaroid__frame">
          {data.photoUrl ? (
            <img src={data.photoUrl} alt={illustrationLabel ?? ''} />
          ) : (
            <HighlightIllustration
              kind={data.illustration ?? 'paws'}
              ariaLabel={illustrationLabel}
            />
          )}
        </div>
        <div className="psl-hl-polaroid__caption">{data.caption}</div>
        {data.stamp && (
          <div className="psl-hl-polaroid__stamp" aria-hidden="true">
            <span>{data.stamp.small}</span>
            <span className="psl-hl-polaroid__stamp-big">{data.stamp.big}</span>
            <span>{data.stamp.tiny}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default HighlightPolaroid;
